<template>
  <div id="MainDialog">
    <div class="dialog_box" data-dialog-box>
      <p class="title">訊息</p>
      <div class="content" v-html="dialogContent"></div>

      <div class="button_box">
        <button
          @click="
            $store.commit('setDialog', {
              status: false,
              content: dialogContent,
            })
          "
        >
          關閉
        </button>
      </div>
    </div>

    <div class="background_box" data-dialog-background></div>
  </div>
</template>

<script>
import { MainDialog } from "@/animations/mainDialog";
export default {
  name: "MainDialog",
  data() {
    return {
      animation: null,
    };
  },
  methods: {
    InitAnimation() {
      this.animation = new MainDialog(document.querySelector("#MainDialog"));
      this.animation.Reset();
    },
    Open() {
      this.animation.Open();
    },
    Close() {
      this.animation.Close();
    },
  },
  computed: {
    dialogStatus() {
      return this.$store.state.mainDialog.status;
    },
    dialogContent() {
      return this.$store.state.mainDialog.content;
    },
  },
  watch: {
    dialogStatus() {
      if (this.dialogStatus) {
        this.Open();
      } else {
        this.Close();
      }
    },
  },
  mounted() {
    this.InitAnimation();
    if (this.dialogStatus) {
      this.Open();
    }
  },
};
</script>
